import * as AuthHelper from './APIHelper';

export const GetHospital = () => {
    return AuthHelper.getResponse('/hospital');
}

export const GetHospitalWithParams = (params) => {
    return AuthHelper.getResponse(`/hospital?${params}`);
}

export const PostHospital = (payload) => {
    return AuthHelper.postResponse('/hospital', payload);
}

export const PutHospital = (id, payload) => {
    return AuthHelper.putResponse(`/hospital/${id}`, payload);
}

export const DeleteHospital = (id) => {
    return AuthHelper.deleteResponse(`/hospital/${id}`);
}

export const GetHospitalFilesWithParams = (params) => {
    return AuthHelper.getResponse(`/hospitalfile?${params}`);
}

export const PostHospitalFile = (payload, url) => {
    return AuthHelper.postFormResponse('/hospitalfile', payload, url);
}

export const DeleteHospitalFile = (id) => {
    return AuthHelper.deleteResponse(`/hospitalfile/${id}`);
}